import { Link } from 'react-router-dom';
import { LibraryContainer, LibraryImgCard, LibaryCard } from './library.styles';
import { Banner } from 'src/utilities/UILibrary/Media/Banner/Banner';

export default function Library() {
  return (
    <LibraryContainer>
      <Banner imgSrc={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_library.jpg`}>
        <h1>Biblioteca</h1>
      </Banner>

      <LibraryImgCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/cbiLac2020.jpg`}
              alt="library landscape"
            />
          </figure>
          <div>
            <p>Estado del mercado en America Latina y el Caribe</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/cbilac2020Sp02dfvEstadoMercadoLatamMexico2021.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/bonosTematicos.jpg`}
              alt="library h2o"
            />
          </figure>
          <div>
            <p>Bonos temáticos</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/bonosTematicosMayo261030pmibd.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/financialInnovationForSME.jpg`}
              alt="library h2o"
            />
          </figure>
          <div>
            <p>Innovación financiera</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/financialInnovationForSmeNetZeroReport.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/dignosticoPerspectivaGenero.jpg`}
              alt="library h2o"
            />
          </figure>
          <div>
            <p>Diagnóstico perspectiva de género</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/diagnosticoPerspectivaGeneroCIIGEF.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/wefImpactInvestingForTheNew.jpg`}
              alt="library h2o"
            />
          </figure>
          <div>
            <p>WEF Inversiones de impacto para las siguientes generaciones</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/WEFImpactInvestingForTheNextGenerationESG.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
        <LibaryCard>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/sistemasFinancierosLatamaYRiesgoClimatico.jpg`}
              alt="library h2o"
            />
          </figure>
          <div>
            <p>Sistemas financieros en LATAM y Riesgo Climatico</p>
            <Link
              to={`${process.env.REACT_APP_BUCKET_FINSPHERA}/sistemasFinancierosLatamYRiesgoclimatico.pdf`}
              download
              target="_blank"
              rel="noreferrer"
            >
              Ir al enlace
            </Link>
          </div>
        </LibaryCard>
      </LibraryImgCard>
    </LibraryContainer>
  );
}
